<template>
    <div>
        <text-input :value="data.name" label="Name" ref="name"></text-input>
        <text-input :value="data.shortTitle" label="Kurztitel" ref="shortTitle"></text-input>
        <long-text-input :value="data.description" label="Kurzbeschreibung"
                        ref="description"></long-text-input>
        <long-text-input :value="data.longDescription" label="Beschreibung"
                        ref="longDescription"></long-text-input>
        <div class="form-group">
            <label for="#chapter-position">Unterkapitel Position</label>
            <input type="number" class="form-control" v-model="position" /> 
        </div>
        <entity-multiselect
                entity="tag"
                label="Tags"
                :value="tagIds"
                @input="changedTags"
                name="tags"></entity-multiselect>
        <file-input v-model="image" label="Bild" type="image"/>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      image: this.data.image,
      position: this.data.position,
      tagIds: this.data.tagIds,
    }
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    saveSubChapter() {
      let form = new FormData();
      const form_prefix = 'edit_sub_chapter';
      for (let id of this.tagIds) {
        form.append(form_prefix + "[tags][]", id);
      }
      if (this.image && this.image.id) {
        form.append(form_prefix + "[image]", this.image.id);
      } else {
        form.append(form_prefix + "[image]", "");
      }
      form.append(form_prefix + "[position]", this.position);
      form.set(form_prefix + "[submit]", null);
      return axios.post(
        `/api/${store.state.language}/sub_chapter/${this.data.id}/edit`,
        form
      );
    },
    save() {
      store.commit("addSavingProcess");
      Promise.all([
        this.saveSubChapter(),
        this.$refs.name.save(),
        this.$refs.shortTitle.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
      ])
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern ist ein Fehler aufgetreten."
          );
        });

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/sub_chapter/General.vue